import goalSettingsStepsSchema from './GoalSettings/stepsSchema';
import dietSettingsStepsSchema from './DietSettings/stepsSchema';
import biometricSettingsStepsSchema from './BiometricSettings/stepsSchema';
import mealPlanSettingsStepsSchema from './MealPlanSettings/stepsSchema';
import packageJson from '../package.json';
export const ALLOWED_LANGUAGES = ['pl-PL'];

export const SENTRY_DSN =
  'https://6125bef1328a45e98c47457321bfc948@o251048.ingest.sentry.io/1436785';

export const APP_STORE_URL =
  'https://apps.apple.com/pl/app/mamhashi-zdrowie-w-hashimoto/id6470379742';
export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.mamhashi.hashimoto.diet&hl=pl';

export const APP_VERSION = packageJson.version;
export const APP_BRAND = 'hashimoto';

export const SLIDE_ROUTES_DURATION = 350;

export const LANDING_URL = 'https://aplikacja.mamhashi.pl/';

export const siteMetadata = {
  lang: 'en',
  shortName: 'Mamhashi',
  name: 'Mamhashi',
  themeColor: '#ffffff',
  title: 'Mamhashi',
  description: 'Aplikacja Mamhashi 💚 Zacznij skutecznie zarządzać swoim Hashimoto!',
  keywords: ['mamhashi'],
  author: 'activerse.app',
};

export const INSTACART_FIREBASE_FUNCTION =
  'https://hashimotoinstacartgenerator-hkzkt3fbeq-uc.a.run.app';
export const INSTACART_URL = 'https://www.instacart.com/store/partner_recipes';

export const FRISCO = true;
export const FRISCO_FIREBASE_FUNCTION = 'https://hashimotofriscogenerator-hkzkt3fbeq-uc.a.run.app';
export const FRISCO_PARTNER = 'Mamhashi';
export const FRISCO_DESKROP_URL_PL = 'https://aplikacja.mamhashi.pl/frisco/';

export const FIRST_DIET_SETTINGS_STEP_SLUG = dietSettingsStepsSchema[0].slug;
export const FIRST_GOAL_SETTINGS_STEP_SLUG = goalSettingsStepsSchema[0].slug;
export const FIRST_BIOMETRIC_SETTINGS_STEP_SLUG = biometricSettingsStepsSchema[0].slug;
export const FIRST_MEAL_PLAN_SETTINGS_STEP_SLUG = mealPlanSettingsStepsSchema[0].slug;

export const FORCE_BUILD = true;

export const OPEN_APP_URL = 'https://pobierz.mamhashi.pl/Z7V0/';
